// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"df2d7589","125":"fbff07d6","340":"020bd50b","498":"983f6f5e","513":"1f1e2e7e","703":"270cf410"}[chunkId] + ".chunk.js";
};